import { render, staticRenderFns } from "./AssetMessage.vue?vue&type=template&id=8f743b92&scoped=true"
import script from "./AssetMessage.vue?vue&type=script&lang=js"
export * from "./AssetMessage.vue?vue&type=script&lang=js"
import style0 from "./AssetMessage.vue?vue&type=style&index=0&id=8f743b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f743b92",
  null
  
)

export default component.exports